export default "__VITE_ASSET__BvAePkZM__"